import React from 'react';
import styled from 'styled-components';
import Header from "../Containers/Header";

// Create a Wrapper component that'll render a <section> tag with some styles
const StyledTopContent = styled.div`
  display: flex;
  align-self: center;
  flex-direction: column;
  z-index: 3;
  width: 100%;
  position: relative;
  
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#0f62bd+0,0c519d+100 */
  background: #0f62bd; /* Old browsers */
  background: -moz-linear-gradient(-45deg, #0f62bd 0%, #0c519d 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(-45deg, #0f62bd 0%,#0c519d 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(135deg, #0f62bd 0%,#0c519d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0f62bd', endColorstr='#0c519d',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

  &::after {
    content: "";
    background: url("/Castle-Background.png") no-repeat center bottom scroll;
    background-size: 100%;
    opacity: 1;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: -1;
    position: absolute;
  }
  
  @media (max-width: 1023px) {
  }
  @media (max-width: 600px) {
  } 
  @media (max-width: 480px) {
  }
`;

const TopContent = (props) => (
  <StyledTopContent>
    <Header/>
    {props.children}
  </StyledTopContent>);

export default TopContent;


// WEBPACK FOOTER //
// ./src/Components/TopContent.js